<template>
	<div class="header-info">
		<div class="text-right account-info">
			<strong >
				{{ email }}
			</strong>
		</div>

		<div v-if="region === 'tw'" class="balance">
			<span>
				{{ $t('wallet.nx-credit') }}
				<strong>{{ $n(balance) }} {{ $t('wallet.points') }}</strong>
			</span>
		</div>

		<div v-else-if="region !== 'global'" class="balance">
			<span>
				{{ $t('wallet.balance') }}
				<strong>{{ currentBalance }}</strong>
			</span>
		</div>

		<div v-else class="balance">
			<span>
				{{ $t('wallet.nx-credit') }}
				<strong>{{ $n(nxCredit) }} {{ currency }}</strong>
			</span>
			<span>
				{{ $t('wallet.nx-prepaid') }}
				<strong>{{ $n(nxPrepaid) }} {{ currency }}</strong>
			</span>
		</div>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
	name: 'accountInfoGroup',
	components: {
		svgIcon,
	},
	props: {
		title: {
			type: String,
		},
		info: {
			type: String,
		}
	},
	data() {
		return {
			tpaType: this.$store.state.userData.AccountSourceType,
		};
	},
	computed: {
		region() {
			return environment.region;
		},
		email() {
			return this.$store.state.userData.Email;
		},
		currency() {
			return this.$store.state.userData.Balance.Currency;
		},
		balance() {
			return this.$store.state.userData.Balance.Amounts[0].Amount;
		},
		currentBalance() {
			return this.$n(this.balance, 'currency', this.currency);
		},
		nxCredit() {
			return this.$store.state.userData.Balance.Amounts[1].Amount;
		},
		nxPrepaid() {
			return this.$store.state.userData.Balance.Amounts[2].Amount;
		}
	},
};
</script>

<style lang="less" scoped>
	.header-info {
		text-align: right;
		font-size: 14px;
		float: right;
		font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
	}
	.balance {
		font-size: 14px;
		font-weight: bold;
		margin-top: 10px;
		color: #666;
		span {
			display: inline-block;
			&:first-child {
				padding-right: 7px;
				:after {
					padding-left:15px;
					color: #4c4c4c;
					content: "|\A0";
					font-size: 13px;
				}
			}
			&:last-child {
				:after {
					content: none;
				}
			}
		}
		strong {
			padding-left: 10px;
			color: #eda03b;
		}
	}
	.tpa {
		position: relative;
		.icon-tpa {
			position: absolute;
			top: -2px;
			left: -25px;
			width: 20px;
			height: 20px;
		}
	}
	@media (max-width: 1024px) {
		#accountInfo {
			font-size: 12px;
			padding-top: 5px;
			&.balance {
				margin-left: 20px;
			}
			strong {
				font-size: 16px;
				padding-top: 4px;
			}
		}
	}
	@media (max-width: 600px) {
		.header-info {
			float: none;
		}
	}
	@media (max-width: 450px) {
		.header-info {
			margin-top: 10px;
			.text-right,
			.balance {
				text-align: left;
			}
			.tpa {
				left: 25px;
			}
			.balance {
				span {
					display: block;
					&:first-child {
						padding-right: 0;
						:after {
							content: none;
						}
					}
					strong {
						display: inline-block;
						min-width: 80px;
					}
				}
			}
		}
	}
	@media (max-width: 320px) {
		.header-info {
			#accountInfo {
				margin-left: 0;
				display: block;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/account-info-group.vue